export enum UserNotificationType {
  CHAT_MESSAGE_USER_NOTIFICATION = 'ChatMessageUserNotification',
  COMMENT_MESSAGE_USER_NOTIFICATION = 'CommentMessageUserNotification',
  ESTATE_STATUS_UPDATED_USER_NOTIFICATION = 'EstateStatusUpdatedUserNotification',
  USER_ESTATE_TASK_ASSIGNED_USER_NOTIFICATION = 'UserEstateTaskAssignedUserNotification',
  USER_ESTATE_TASK_CHANGED_STATUS_NOTIFICATION = 'UserEstateTaskChangedStatusNotification',
  REPLY_BY_EMAIL_ON_INACTIVE_CONVERSATION_USER_NOTIFICATION = 'ReplyByEmailOnInactiveConversationUserNotification'
}
